//#region src/core/i18n/text/errors.ts
const prefix = "errors.";
const abortedText = {
	key: `${prefix}aborted`,
	text: "You stopped media playback before it finished."
};
const networkText = {
	key: `${prefix}network`,
	text: "This media could not be loaded due to a network or server issue."
};
const decodeText = {
	key: `${prefix}decode`,
	text: "This media could not be played. It may be corrupted, or your browser may not support its format."
};
const sourceText = {
	key: `${prefix}source`,
	text: "This media could not be loaded. It may be unavailable, or your browser may not support its format."
};
const encryptedText = {
	key: `${prefix}encrypted`,
	text: "This media could not be played because it could not be decrypted."
};
const unplayableText = {
	key: `${prefix}unplayable`,
	text: "This media is unsupported by the player."
};
const titleText = {
	key: `${prefix}title`,
	text: "Something went wrong."
};
const unexpectedText = {
	key: `${prefix}unexpected`,
	text: "An unexpected error occurred."
};
//#endregion
export { abortedText, decodeText, encryptedText, networkText, sourceText, titleText, unexpectedText, unplayableText };

//# sourceMappingURL=errors.js.map